export default {"src":"/_next/static/media/telegram-logo.5bf8ce91.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};